"use client";

import { useAlgoliaSearchModal } from "~/features/algolia/hooks";
import styles from "./SearchBackdrop.module.css";

export const SearchBackdrop = () => {
	const { isOpen, closeModal } = useAlgoliaSearchModal();
	return (
		<>{isOpen && <div id="searchBackdrop" className={styles.backdrop} onClick={closeModal} />}</>
	);
};
